var exports = {
  "jw": "MessageThreadChip.module__chip___UFUweD",
  "nM": "MessageThreadChip.module__row___UFUweD",
  "UU": "MessageThreadChip.module__name___UFUweD",
  "U9": "MessageThreadChip.module__count___UFUweD",
  "VH": "MessageThreadChip.module__preview___UFUweD",
};

module.exports = exports;
